import { ActionTypes } from 'common/actions'
import { Params } from 'common/services/QueryParams'

// NO-OP since params are read-only

export const initialParamsState = {}

export default (state: Params = initialParamsState, action: ActionTypes) => state
